import { useCallback, useEffect, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";

import {
  usePatchClaimantByIdMutation,
  useGetClaimantByIdQuery,
} from "services/claimant-api";

import { useSelector } from "utils/redux";
import { getClaimantForm } from "forms/claimant";

import ClaimantPageContainer from "./ClaimantPageContainer";
import KaboodleForm from "components/Forms/KaboodleForm";

import { setIsLoading } from "reducers/main";
import { useDispatch } from "utils/redux";

const ClaimantForm = () => {
  const dispatch = useDispatch();
  const { claimantId } = useParams<{ claimantId?: string }>();

  const {
    data: claimant,
    isLoading,
    refetch: refetchClaimant,
  } = useGetClaimantByIdQuery({ id: claimantId }, { skip: !claimantId });

  useEffect(() => {
    dispatch(setIsLoading(isLoading));
  }, [dispatch, isLoading]);

  const [patchClaimantById] = usePatchClaimantByIdMutation();

  const { reset, clearErrors, setError } = useFormContext();

  const constants = useSelector((state) => state.shared.constants);

  useEffect(() => {
    if (claimant) {
      reset(claimant);
    }
    refetchClaimant();
  }, [claimant, reset]);

  const handleSave = useCallback(
    async (field: string, value: string | number) => {
      if (claimantId) {
        try {
          await patchClaimantById({
            id: claimantId,
            data: { [field]: value },
          }).unwrap();
          clearErrors(field);
        } catch (error) {
          setError(field, {
            type: error.status,
            message: error.data[field][0],
          });
        }
      }
    },
    [patchClaimantById, claimantId, setError],
  );

  const claimantFormContent = useMemo(() => {
    const forms = getClaimantForm(constants);
    return <KaboodleForm cards={forms[0].cards || []} onSave={handleSave} />;
  }, [constants, handleSave]);

  return <ClaimantPageContainer>{claimantFormContent}</ClaimantPageContainer>;
};

export default ClaimantForm;
